import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { FaTimes, FaExclamationCircle, FaCheckCircle } from 'react-icons/fa';
import { showToast } from '../Toast/Toast';
import CustomButton from '../CustomButton';
import './PrivateContentAccessModal.css';

const PrivateContentAccessModal = ({ show, onHide, userName, userId }) => {
  const [step, setStep] = useState(1); // 1: Confirmation, 2: Success
  const [processing, setProcessing] = useState(false);
  const [isAdding, setIsAdding] = useState(true); // true = adding, false = removing

  const handleConfirm = async () => {
    try {
      setProcessing(true);
      
      // Simulate API call delay
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // TODO: Add API call here when ready
      // const response = await togglePrivateContentAccess(userId, isAdding);
      
      setStep(2);
    } catch (error) {
      console.error('Error toggling private content access:', error);
      showToast(error.message || 'Failed to update access', 'error');
    } finally {
      setProcessing(false);
    }
  };

  const handleCancel = () => {
    setStep(1);
    onHide();
  };

  const handleSuccessClose = () => {
    setStep(1);
    onHide();
  };

  const renderConfirmationStep = () => (
    <div className="private-content-access-modal-content">
      <div className="private-content-access-icon-wrapper">
        <FaExclamationCircle className="private-content-access-icon" />
      </div>
      <h4 className="private-content-access-modal-title">Add/Remove Private Content Access</h4>
      <p className="private-content-access-modal-question">
        Are you sure you want to {isAdding ? 'grant' : 'revoke'} private content access to <strong>{userName || 'this user'}</strong>?
      </p>
      <div className="private-content-access-modal-buttons">
        <CustomButton
          onClick={handleConfirm}
          disabled={processing}
          className="private-content-access-yes-btn"
        >
          {processing ? 'Processing...' : 'Yes'}
        </CustomButton>
        <CustomButton
          onClick={handleCancel}
          variant="secondary"
          className="secondaryButton"
        >
          No
        </CustomButton>
      </div>
    </div>
  );

  const renderSuccessStep = () => (
    <div className="private-content-access-modal-content">
      <div className="success-icon-wrapper">
        <FaCheckCircle className="success-icon" />
      </div>
      <h4 className="private-content-access-modal-title">Successful</h4>
      <p className="success-message">
        Private content access has been {isAdding ? 'granted to' : 'revoked from'} {userName || 'the user'} successfully!
      </p>
      <div className="private-content-access-form-buttons">
        <CustomButton
          onClick={handleSuccessClose}
          className="private-content-access-ok-btn"
        >
          Ok
        </CustomButton>
      </div>
    </div>
  );

  return (
    <Modal show={show} onHide={handleCancel} centered className="private-content-access-modal">
      <Modal.Body className="private-content-access-modal-body">
        <button className="modal-close-btn" onClick={handleCancel}>
          <FaTimes />
        </button>
        
        {step === 1 && renderConfirmationStep()}
        {step === 2 && renderSuccessStep()}
      </Modal.Body>
    </Modal>
  );
};

export default PrivateContentAccessModal;

